<template>
  <div class="sidebar">
    <div class="sidebar-logo">
      <i class="el-icon-link" style="font-size: 24px;"></i>
      <span style="margin-left: 10px;">优特科保</span>
    </div>
    <div class="sidebar-menu-wrapper">
      <el-menu :default-active="activeMenu" class="el-menu-vertical-demo" background-color="#304156" text-color="#fff"
               active-text-color="#ffd04b" router>
        <!-- 动态菜单 -->
        <template v-for="item in menuList" >
          <!-- 子菜单 -->
          <el-submenu v-if="item.child && item.child.length > 0" :index="item.code" :key="item.id">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <!-- 子菜单项 -->
            <el-menu-item v-for="childItem in item.child" :key="childItem.id" :index="childItem.code">
              <i :class="childItem.icon"></i>
              <span slot="title">{{ childItem.name }}</span>
            </el-menu-item>
          </el-submenu>
          <!-- 菜单项 -->
          <el-menu-item v-else :index="item.code" @click="handleMenuClick(item)">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import {resourceList} from "@/api/user";

export default {
  name: 'Sidebar',
  data() {
    return {
      menuList: [],
      activeMenu: 'dashboard'
    }
  },
  created() {
    this.fetchMenuList();
    this.setActiveMenu();
  },
  watch: {
    $route: {
      handler() {
        this.setActiveMenu();
      },
      immediate: true
    },
    // 监听 token 变化，登录成功后重新获取菜单
    '$route.path': {
      handler(newPath) {
        if (newPath !== '/login' && localStorage.getItem('token')) {
          this.fetchMenuList();
        }
      },
      immediate: true
    },
    // 监听 token 变化
    'localStorage.token': {
      handler() {
        if (localStorage.getItem('token')) {
          this.fetchMenuList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取菜单列表
    async fetchMenuList() {
      try {
        const token = localStorage.getItem('token');
        // 检查本地缓存
        const cachedMenu = localStorage.getItem('cachedMenu');
        const cachedToken = localStorage.getItem('cachedMenuToken');

        // 如果有缓存且 token 匹配，直接使用缓存数据
        if (cachedMenu && cachedToken === token) {
          this.menuList = JSON.parse(cachedMenu);
          return;
        }

        // 没有缓存或 token 不匹配，调用 API 获取新数据
        const resp = await resourceList();
        if (resp && resp.code === "0000"){
          this.menuList = resp.result || [];
          // 存储到本地缓存
          localStorage.setItem('cachedMenu', JSON.stringify(this.menuList));
          localStorage.setItem('cachedMenuToken', token);
        }

      } catch (e) {
        console.error('获取菜单列表失败:', e);
        this.menuList = [];
      }
    },
    // 设置当前激活的菜单
    setActiveMenu() {
      const path = this.$route.name;
      this.activeMenu = path || 'dashboard';
    },
    // 处理菜单项点击事件
    handleMenuClick(item) {
      // 检查是否是数据大屏菜单
      if (item.code === 'dataview') {
        // 获取 token
        const token = localStorage.getItem('token');
        // 外部网站地址
        const externalUrl =  process.env.VUE_APP_DATA_VIEW_URL + '/#/external-login'; // 替换为实际的外部网站地址
        console.log('externalUrl', externalUrl)
        // 构建带 token 的 URL
        const urlWithToken = `${externalUrl}?token=${encodeURIComponent(token)}`;
        // 跳转到外部网站
        window.open(urlWithToken, '_blank');
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-logo {
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #48576a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}


/* 新增：菜单包装器，用于滚动 */
.sidebar-menu-wrapper {
  flex: 1; /* 占据剩余空间 */
  overflow-y: auto; /* 垂直滚动条 */
  overflow-x: hidden; /* 隐藏水平滚动条 */
}

/* 滚动条样式定制 */
.sidebar-menu-wrapper::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

.sidebar-menu-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2); /* 滚动条颜色 */
  border-radius: 3px; /* 圆角 */
}

.sidebar-menu-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.4); /* 悬停时的颜色 */
}

::v-deep .el-submenu__title {
  background-color: #304156 !important;
}

::v-deep .el-submenu__title:hover {
  background-color: #1f2d3d !important;
}

::v-deep .el-menu-item:hover {
  background-color: #1f2d3d !important;
}

::v-deep .el-menu-item.is-active {
  background-color: #1f2d3d !important;
}
</style>
